import { io } from "socket.io-client";
import { clearAuthToken } from "../graphql/client.js";

let socket = null;
let onForceLogout = null;

export const connectPresenceSocket = (token, logoutCallback) => {
    if (socket?.connected) return socket;

    onForceLogout = logoutCallback;

    socket = io(`${import.meta.env.VITE_API_BASE_URL}/presence`, {
        auth: { token },
        transports: ["polling"],
    });

    socket.on("force_logout", () => {
        clearAuthToken();
        if (onForceLogout) onForceLogout();
    });

    socket.on("session_changed", (data) => {
        window.dispatchEvent(new CustomEvent("palzea:session_changed", { detail: data }));
    });

    return socket;
};

export const disconnectPresenceSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
    onForceLogout = null;
};
